// Central content for the Biz360 Compliance homepage.

// Sub-links for the "Registration" nav dropdown (flat — used by the mobile
// accordion). Mega-menu tabs below are the desktop source of truth.
export const NAV_REGISTRATION = [
  { label: "Private Limited Company", href: "/registration/private-limited-company" },
  { label: "Limited Liability Partnership (LLP)", href: "/registration/llp" },
  { label: "One Person Company (OPC)", href: "/registration/one-person-company" },
  { label: "Partnership Firm", href: "/registration/partnership-firm" },
  { label: "Sole Proprietorship", href: "/registration/sole-proprietorship" },
  { label: "Section 8 Company", href: "/registration/section-8-company" },
  { label: "Producer Company", href: "/registration/producer-company" },
  { label: "Trust / NGO Registration", href: "/registration/trust-registration" },
  { label: "Udyam Registration", href: "/business-licences/udyam-registration" },
  { label: "FSSAI Registration & Licence", href: "/business-licences/fssai-registration-licence" },
  { label: "Import Export Code (IEC)", href: "/business-licences/import-export-code-iec" },
  { label: "Maharashtra Shop & Establishment", href: "/business-licences/maharashtra-shop-establishment" },
];

// Sub-links for the "Taxation" nav dropdown (mobile fallback).
export const NAV_TAXATION = [
  { label: "All Taxation Services", href: "/taxation" },
  { label: "GST Services", href: "/taxation/gst" },
  { label: "Income Tax", href: "/taxation/income-tax" },
];

// Sub-links for the "Compliance" nav dropdown (mobile fallback).
export const NAV_COMPLIANCE = [
  { label: "All Compliance Services", href: "/compliance" },
  { label: "Accounting & Finance", href: "/accounting-finance" },
  { label: "Corporate Compliance", href: "/compliance#corporate-compliance" },
  { label: "Payroll & Labour Compliance", href: "/compliance#payroll-labour-compliance" },
  { label: "Compliance Management & Advisory", href: "/compliance#compliance-management-advisory" },
];

// Desktop mega-menu content: each top-level nav item with a `mega` config
// renders as tabs (subcategories) on the left and that tab's services on
// the right, instead of a flat dropdown list. Slugs/titles here match the
// CMS `services` table (category/sub_category/slug/title columns).
export const NAV_MEGA = {
  Registration: {
    hubHref: "/registration",
    hubLabel: "View all Registration services",
    tabs: [
      {
        label: "Company Registration",
        href: "/registration#company-registration",
        items: [
          { label: "Private Limited Company", href: "/registration/private-limited-company" },
          { label: "Limited Liability Partnership (LLP)", href: "/registration/llp" },
          { label: "One Person Company (OPC)", href: "/registration/one-person-company" },
          { label: "Producer Company", href: "/registration/producer-company" },
        ],
      },
      {
        label: "Traditional Structures",
        href: "/registration#traditional-structures",
        items: [
          { label: "Partnership Firm", href: "/registration/partnership-firm" },
          { label: "Sole Proprietorship", href: "/registration/sole-proprietorship" },
        ],
      },
      {
        label: "NGO & Trust",
        href: "/registration#non-profit",
        items: [
          { label: "Trust / NGO Registration", href: "/registration/trust-registration" },
          { label: "Section 8 Company", href: "/registration/section-8-company" },
        ],
      },
      {
        label: "Business Licences",
        href: "/business-licences",
        items: [
          { label: "Udyam Registration", href: "/business-licences/udyam-registration" },
          { label: "FSSAI Registration & Food Licence", href: "/business-licences/fssai-registration-licence" },
          { label: "Import Export Code (IEC)", href: "/business-licences/import-export-code-iec" },
          { label: "Maharashtra Shops & Establishments", href: "/business-licences/maharashtra-shop-establishment" },
        ],
      },
    ],
  },
  Taxation: {
    hubHref: "/taxation",
    hubLabel: "View all Taxation services",
    tabs: [
      {
        label: "GST Services",
        href: "/taxation/gst",
        items: [
          { label: "GST Registration", href: "/taxation/gst/gst-registration" },
          { label: "GST Return Filing", href: "/taxation/gst/gst-return-filing" },
          { label: "GSTR-9 & GSTR-9C Filing", href: "/taxation/gst/gstr-9-gstr-9c-filing" },
          { label: "GST Refund & Export Refund", href: "/taxation/gst/gst-refund" },
          { label: "LUT Registration", href: "/taxation/gst/lut-registration" },
          { label: "GST Notice Reply", href: "/taxation/gst/gst-notice-reply" },
          { label: "GST Amendment", href: "/taxation/gst/gst-amendment" },
          { label: "GST Cancellation", href: "/taxation/gst/gst-cancellation" },
          { label: "GST Annual Compliance", href: "/taxation/gst/gst-annual-compliance" },
          { label: "GST Advisory", href: "/taxation/gst/gst-advisory" },
        ],
      },
      {
        label: "Income Tax",
        href: "/taxation/income-tax",
        items: [
          { label: "Income Tax Return Filing", href: "/taxation/income-tax/income-tax-return-filing" },
          { label: "Advance Tax Compliance", href: "/taxation/income-tax/advance-tax-compliance" },
          { label: "Tax Audit Support", href: "/taxation/income-tax/tax-audit-support" },
          { label: "Income Tax Planning & Advisory", href: "/taxation/income-tax/income-tax-planning-advisory" },
          { label: "Capital Gains Tax Advisory", href: "/taxation/income-tax/capital-gains-tax-advisory" },
          { label: "NRI Taxation & Compliance", href: "/taxation/income-tax/nri-taxation-compliance" },
          { label: "PAN & TAN Services", href: "/taxation/income-tax/pan-tan-services" },
          { label: "Income Tax Notice & Assessment", href: "/taxation/income-tax/income-tax-notice-assessment-support" },
          { label: "Tax Demand & Rectification", href: "/taxation/income-tax/tax-demand-rectification-support" },
          { label: "Assessment & Representation", href: "/taxation/income-tax/tax-representation-assessment-support" },
          { label: "Appeals & Litigation Support", href: "/taxation/income-tax/income-tax-appeals-litigation" },
          { label: "Form 15CA / 15CB Support", href: "/taxation/income-tax/form-15ca-15cb-support" },
        ],
      },
      {
        label: "TDS",
        href: "/taxation/tds",
        items: [
          { label: "TDS Compliance & Return Filing", href: "/taxation/income-tax/tds-compliance-filing" },
          { label: "Lower / Nil TDS Certificate", href: "/taxation/income-tax/lower-nil-tds-certificate" },
        ],
      },
    ],
  },
  Compliance: {
    hubHref: "/compliance",
    hubLabel: "View all Compliance services",
    tabs: [
      {
        // Accounting & Finance lives under Compliance in the nav, but keeps its
        // own /accounting-finance hub and service routes. Tab `href`s are never
        // rendered (tabs are hover/tap buttons), so the hub is linked as the
        // first item to keep it reachable.
        label: "Accounting & Finance",
        href: "/accounting-finance",
        items: [
          { label: "All Accounting & Finance Services", href: "/accounting-finance" },
          { label: "Bookkeeping & Accounting", href: "/accounting-finance/bookkeeping-accounting" },
          { label: "Monthly Accounting & Closing", href: "/accounting-finance/monthly-accounting-closing" },
          { label: "Accounts Finalisation & Financial Statements", href: "/accounting-finance/accounts-finalisation" },
          { label: "MIS Reporting", href: "/accounting-finance/mis-reporting" },
          { label: "Virtual CFO Services", href: "/accounting-finance/virtual-cfo-services" },
          { label: "Project Reports & CMA Data", href: "/accounting-finance/project-reports-cma-data" },
          { label: "Cash Flow & Working Capital", href: "/accounting-finance/cash-flow-working-capital" },
          { label: "Financial Planning & Advisory", href: "/accounting-finance/financial-planning-advisory" },
        ],
      },
      {
        label: "Corporate Compliance",
        href: "/compliance#corporate-compliance",
        items: [
          { label: "ROC & MCA Annual Compliance", href: "/compliance/roc-mca-annual-compliance" },
          { label: "LLP Annual Compliance", href: "/compliance/llp-annual-compliance" },
          { label: "Event-Based ROC & MCA Compliance", href: "/compliance/event-based-roc-mca-compliance" },
          { label: "Director & DIN Compliance", href: "/compliance/director-din-compliance" },
        ],
      },
      {
        label: "Payroll & Labour Compliance",
        href: "/compliance#payroll-labour-compliance",
        items: [
          { label: "Payroll Processing & Compliance", href: "/compliance/payroll-processing-compliance" },
          { label: "PF / EPF Compliance", href: "/compliance/pf-epf-compliance" },
          { label: "ESI Compliance", href: "/compliance/esi-compliance" },
          { label: "Professional Tax Compliance", href: "/compliance/professional-tax-compliance" },
          { label: "Labour Law Compliance", href: "/compliance/labour-law-compliance" },
        ],
      },
      {
        label: "Compliance Management & Advisory",
        href: "/compliance#compliance-management-advisory",
        items: [
          { label: "Annual Compliance Management", href: "/compliance/annual-compliance-management" },
          { label: "Business Compliance Health Check", href: "/compliance/compliance-health-check" },
        ],
      },
    ],
  },
  "Other Services": {
    hubHref: "/other-services",
    hubLabel: "View all Other Services",
    tabs: [
      {
        label: "Other Services",
        href: "/other-services",
        items: [
          { label: "Tax Audit Support Services", href: "/other-services/audit-support-services" },
          { label: "Internal Audit Support", href: "/other-services/internal-audit-support" },
          { label: "Internal Controls & Process Review", href: "/other-services/internal-controls-process-review" },
          { label: "Certification & Documentation Support", href: "/other-services/certification-documentation-support" },
          { label: "Startup India / DPIIT Recognition", href: "/other-services/startup-india-dpiit-recognition" },
          { label: "MSME Advisory", href: "/other-services/msme-advisory" },
          { label: "Government Scheme Advisory", href: "/other-services/government-scheme-advisory" },
          { label: "CMEGP / PMEGP Assistance", href: "/other-services/cmegp-pmegp-assistance" },
          { label: "Funding & Subsidy Advisory", href: "/other-services/funding-subsidy-advisory" },
          { label: "Business Structuring Advisory", href: "/other-services/business-structuring-advisory" },
          { label: "Process & System Advisory", href: "/other-services/process-system-advisory" },
        ],
      },
    ],
  },
};

export const NAV_LINKS = [
  { label: "Home", href: "/" },
  { label: "Registration", href: "/registration", dropdown: NAV_REGISTRATION, mega: NAV_MEGA.Registration },
  { label: "Taxation", href: "/taxation", dropdown: NAV_TAXATION, mega: NAV_MEGA.Taxation },
  { label: "Compliance", href: "/compliance", dropdown: NAV_COMPLIANCE, mega: NAV_MEGA.Compliance },
  { label: "Other Services", href: "/other-services", mega: NAV_MEGA["Other Services"] },
];

export const NAV_MORE = [
  { label: "About", href: "/about" },
  { label: "Knowledge Centre", href: "/blogs" },
  { label: "Pricing", href: "/pricing" },
  { label: "FAQ", href: "/faq" },
];

export const PHONE = "+91 90673 68357";
export const EMAIL = "biz360compliance@gmail.com";

// Office address — the only copy. Used by the footer, Contact cards and the
// Contact page map embed.
export const ADDRESS_LINES = [
  "OFC No. 70, Patil Arcade, above Hotel Kalinga",
  "Khilare Road, Near Sharda Center, Erandwane, Pune, Maharashtra 411004",
];
export const ADDRESS = ADDRESS_LINES.join(", ");

// WhatsApp deep link with a prefilled first message, built from PHONE so the
// number only ever lives in one place.
export const WHATSAPP_MESSAGE =
  "Hi Biz360 Compliance, I'd like to know more about your services.";
export const WHATSAPP_HREF = `https://wa.me/91${PHONE.replace(/\D/g, "").slice(-10)}?text=${encodeURIComponent(
  WHATSAPP_MESSAGE
)}`;
export const MAP_EMBED_SRC = `https://maps.google.com/maps?q=${encodeURIComponent(ADDRESS)}&t=&z=15&ie=UTF8&iwloc=&output=embed`;

export const TRUST_STRIP = [
  "Professional-Led Services",
  "100% Online",
  "PAN India",
  "Dedicated RM",
  "Transparent Pricing",
  "Fast Turnaround",
];

export const STATS = [
  { value: 100, suffix: "%", label: "Compliant", sub: "ISO-Level data security" },
  { value: 1000, suffix: "+", label: "Businesses Registered", sub: "Across every state" },
  { value: 1000, suffix: "+", label: "GST Registrations", sub: "Filed & approved" },
  { value: 2500, suffix: "+", label: "Returns Filed", sub: "On-time, every time" },
  { value: 10, suffix: "+", label: "Years of Experience", sub: "Professional-led advisory" },
];

export const FEATURES = [
  { icon: "GraduationCap", title: "Experienced Professionals", desc: "Qualified CAs, CSs and legal advisors guiding your business at every step." },
  { icon: "Layers", title: "End-to-End Compliance", desc: "Registration to filings to advisory — the full lifecycle in one place." },
  { icon: "UserCheck", title: "Dedicated Manager", desc: "A single relationship manager who owns your account end-to-end." },
  { icon: "IndianRupee", title: "Transparent Pricing", desc: "Clear, upfront quotes with zero hidden charges or surprises." },
  { icon: "Zap", title: "Fast Turnaround", desc: "Streamlined workflows that cut days off standard processing times." },
  { icon: "Lock", title: "Secure Documents", desc: "Bank-grade encryption keeps your financial data private and safe." },
  { icon: "BellRing", title: "Compliance Reminders", desc: "Automated alerts so you never miss a statutory due date again." },
  { icon: "HeartHandshake", title: "Long-Term Support", desc: "We stay with you as you grow — advisory beyond the paperwork." },
];


// Titles/items here are kept in sync with NAV_MEGA's tabs above — each card
// maps 1:1 to a real mega-menu tab so every link resolves to a live CMS page.
export const SERVICES = [
  {
    icon: "Building2",
    title: "Business Registration",
    items: ["Private Limited Company", "Limited Liability Partnership (LLP)", "One Person Company (OPC)", "Partnership Firm", "Sole Proprietorship"],
  },
  {
    icon: "Receipt",
    title: "GST Services",
    items: ["GST Registration", "Return Filing", "Amendments", "Refunds", "LUT"],
  },
  {
    icon: "Calculator",
    title: "Accounting & Finance",
    items: ["Bookkeeping", "Virtual CFO", "Project Reports", "MIS Reporting"],
  },
  {
    icon: "BadgeCheck",
    title: "Business Licence & Registration",
    items: ["Udyam", "Shop & Est.", "FSSAI", "IEC"],
  },
  {
    icon: "Users",
    title: "Payroll & Labour Compliance",
    items: ["PF Registration", "ESIC", "Professional Tax", "Payroll", "Compliance"],
  },
  {
    icon: "Landmark",
    title: "Corporate Compliance",
    items: ["AOC-4", "MGT-7", "DIN KYC", "DIR Forms", "Annual Filings"],
  },
  {
    icon: "FileText",
    title: "Income Tax",
    items: ["ITR Filing", "Tax Planning", "PAN / TAN", "TDS Returns", "Tax Notices"],
  },
  {
    icon: "ClipboardList",
    title: "Other Services",
    items: ["Tax Audit Support", "Internal Audit Support", "Startup India / DPIIT", "MSME Advisory"],
  },
];

export const INDUSTRIES = [
  "Manufacturing", "Trading", "Retail", "Healthcare", "Construction",
  "Education", "Hospitality", "IT & Software", "E-commerce", "Logistics",
  "Agriculture", "NGOs", "Import & Export", "Professional Firms",
  "Real Estate", "Startups", "Restaurants",
];

export const JOURNEY = [
  { no: "01", title: "Submit Enquiry", desc: "Share your requirement through a quick form or a call." },
  { no: "02", title: "Free Consultation", desc: "Our expert maps the right structure for you." },
  { no: "03", title: "Document Collection", desc: "Upload documents securely — we handle the checklist." },
  { no: "04", title: "Business Compliance", desc: "We prepare, review and file with the authorities." },
  { no: "05", title: "Certificate Delivery", desc: "Receive your certificates and approvals, digitally." },
  { no: "06", title: "Ongoing Support", desc: "Reminders, filings and advisory as your business grows." },
];


export const ARTICLES = [
  {
    tag: "Structuring",
    title: "Private Limited vs LLP: Which structure fits your startup?",
    read: "6 min read",
    img: "https://images.unsplash.com/photo-1554224154-26032ffc0d07?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    tag: "Taxation",
    title: "GST returns explained: due dates, penalties and how to stay ahead",
    read: "8 min read",
    img: "https://images.unsplash.com/photo-1554224155-6726b3ff858f?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
  {
    tag: "Compliance",
    title: "Annual ROC filings: the founder's checklist for a clean financial year",
    read: "5 min read",
    img: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
  },
];


export const FAQS = [
  {
    q: "How long does company registration take?",
    a: "Most Private Limited Companies and LLPs are registered within 7–10 working days, provided all documents are in order. We handle the entire SPICe+ filing process for you.",
  },
  {
    q: "Do I need to visit your office in person?",
    a: "No. Biz360 Compliance is 100% online — documents are uploaded securely, and your dedicated Relationship Manager coordinates everything over call, email and WhatsApp.",
  },
  {
    q: "Are your services led by qualified professionals?",
    a: "Yes. Every engagement — from registration to filings to advisory — is reviewed and signed off by a qualified expert on our team.",
  },
  {
    q: "What happens if I miss a compliance deadline?",
    a: "We send automated reminders well ahead of every statutory due date. If you're on a Growth or Enterprise plan, your Relationship Manager proactively tracks filings so nothing slips through.",
  },
  {
    q: "Can I switch plans later as my business grows?",
    a: "Absolutely. You can upgrade from Starter to Growth or a custom Enterprise plan at any time — we'll simply adjust the scope and continue without any disruption to ongoing filings.",
  },
  {
    q: "Is my financial data secure with Biz360?",
    a: "Yes. We use bank-grade encryption for document storage and transfer, and access is restricted to the CAs and staff directly working on your account.",
  },
  {
    q: "Do you provide business registration and compliance support across Maharashtra including Pune, Parbhani, and Mumbai?",
    a: "Yes. While Biz360 Compliance serves businesses PAN India with a 100% digital process, our headquarters in Pune provides deep regional grounding across Maharashtra. We regularly assist founders, MSMEs, and commercial enterprises in Pune, Parbhani, Mumbai, Chhatrapati Sambhajinagar, Nagpur, Nanded, and Latur with ROC filings (ROC Pune and ROC Mumbai), Maharashtra Shop & Establishment (Gumasta), and Professional Tax (PTRC/PTEC).",
  },
  {
    q: "What specific registrations are mandatory to start and run a business in Maharashtra?",
    a: "Beyond central MCA incorporation and PAN/TAN, commercial entities in Maharashtra generally require: (1) Maharashtra Shop & Establishment Intimation/Registration (Gumasta) under the 2017 Act, (2) Professional Tax Registration under PTEC (for the firm/directors) and PTRC (for employer salary deduction), (3) GST Registration if turnover exceeds statutory thresholds or for inter-state transactions, and (4) Udyam Registration for MSME priority and state subsidies.",
  },
];

export const HERO_IMAGE =
  "https://images.unsplash.com/photo-1735825764485-93a381fd5779?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjBmaW5hbmNlJTIwd29ya3NwYWNlfGVufDB8fHx8MTc4MzE3MDIyNHww&ixlib=rb-4.1.0&q=85";
